import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { config } from '@app/config/app';
import { Store } from '@app/config/store';
import { HeaderComponent } from '@app/shared/header/header.component';
import { Menu, SidenavComponent } from '@app/shared/sidenav/sidenav.component';
import { environment } from '@env/environment';

@Component({
  selector: 'app-private',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, SidenavComponent],
  templateUrl: './private.component.html',
  styleUrl: './private.component.css',
})
export class PrivateComponent implements OnInit {
  protected store = inject(Store);

  sidenavMenu: Menu[] = [
    {
      title: '',
      route: '',
      icon: '',
      menu: [
        // {
        //   title: 'Dashboard',
        //   route: '/sapphire/dashboard',
        //   icon: 'matDashboardOutline',
        //   class: '!tw-mt-1',
        // },
        {
          title: 'GST Compliance 1.0',
          click: () => {
            window.location.href = `${config.sapphire1WebUrl}#/tokenVerify?token=${this.store.authToken()}&sapphireTenent=asp`;
          },
          icon: 'matDashboardOutline',
          class: '!tw-mt-1',
        },
      ],
    },
    {
      title: 'Returns',
      route: '',
      icon: '',
      menu: [
        {
          title: 'GSTR 1',
          route: '/sapphire/gstr1',
          icon: 'matStackedLineChart',
        },
        {
          title: 'GSTR 3B',
          route: '/sapphire/gstr3b',
          icon: 'matStackedLineChart',
        },
        {
          title: 'GSTR 1A',
          route: '/sapphire/gstr1A',
          icon: 'matStackedLineChart',
        },
        {
          title: 'GSTR 2X',
          route: '/sapphire/gstr2x/view',
          icon: 'matStackedLineChart',
        },
      ],
    },
    // {
    //   title: '',
    //   route: '',
    //   icon: '',
    //   menu: [
    //     {
    //       title: 'Tools',
    //       route: '/tools',
    //       icon: 'matConstruction',
    //       class: '!tw-mt-2',
    //     },
    //   ],
    // },
  ];

  ngOnInit(): void {
    if (environment.GSTR6_ENABLED || environment.RECON_ENABLED) {
      if (environment.GSTR6_ENABLED) {
        this.sidenavMenu[1].menu?.push({
          title: 'GSTR 6',
          route: '/sapphire/gstr6',
          icon: 'matStackedLineChart',
        });
      }
      if (environment.RECON_ENABLED) {
        if (this.sidenavMenu?.length) {
          this.sidenavMenu.push({
            title: 'Reconciliation',
            route: '',
            icon: '',
            menu: [
              {
                title: '2B Purchaser Data',
                icon: 'matArrowCircleRightOutline',
                route: '',
                class: 'justify-content-between',
                flyout: [
                  {
                    title: 'B2B & CDN Recon Result',
                    route: '/sapphire/recon/2b/snapshot',
                    icon: 'matStackedLineChart',
                  },
                ],
              },
              {
                title: 'IMS Based Purchase Recon',
                icon: 'matArrowCircleRightOutline',
                route: '',
                class: 'justify-content-between',
                flyout: [
                  {
                    title: 'Get & IMS Action',
                    route: '/sapphire/recon/imsDataFetch/getData',
                    icon: 'matStackedLineChart',
                  },
                ],
              },
            ],
          });
        }
      } else {
        this.sidenavMenu[1].menu = this.sidenavMenu[1].menu?.filter(
          (m) => m.route !== '/sapphire/gstr6',
        );
      }
    }
  }
}
